import React from 'react';
import { BaseSelect } from '@/core/components/BaseSelect/BaseSelect';
import './CustomPeriodSelect.scss';
export type { SelectOption as CustomPeriodSelectOption } from '@/core/components/BaseSelect/BaseSelect';

interface CustomPeriodSelectProps {
  options: { label: string; value: string }[];
  value?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  className?: string;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  disabled?: boolean;
}

export const CustomPeriodSelect: React.FC<CustomPeriodSelectProps> = ({ className, ...props }) => (
  <BaseSelect {...props} className={`period-select ${className ?? ''}`} />
);